import { render, staticRenderFns } from "./areaview.vue?vue&type=template&id=0e63dc7a&scoped=true"
import script from "./areaview.vue?vue&type=script&lang=js"
export * from "./areaview.vue?vue&type=script&lang=js"
import style0 from "./areaview.vue?vue&type=style&index=0&id=0e63dc7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e63dc7a",
  null
  
)

export default component.exports